import {useState, useContext, useEffect} from 'react'
import DropdownCustom from '../../../components/DropdownCustom'
import {useDashboardFiltersContext} from '../context/dashboard-filter.context'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import {Button} from '@zebra-fed/zds-react-desktop'
import {userJustManager} from '../../../data/userUtil'
import {AuthContext} from '../../../authentication/Auth'
import app from '../../../authentication/firebaseStart'
import { getKioskNames } from '../../../data/FirebaseUtil'

const ButtonDiv = styled.div`
  display: flex;
  @media screen and (max-width: 750px) {
    flex-direction: column;
  }
`

export const DashboardFilters = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [enableCheckboxForSites, setEnableCheckboxForSites] = useState(true)
  const [enableCheckboxForCabinets, setEnableCheckboxForCabinets] =
    useState(true)
  const [placeholderSites] = useState('Select Sites')
  const [placeholderCabinets] = useState('Select Kiosks')

  const context = useContext(AuthContext)
  const firestore = app.firestore()
  const isManager = userJustManager(context.currentUser.claims)
  const {
    sitesData,
    setSitesData,
    cabinetsData,
    setCabinetsData,
    selectedSites,
    setSelectedSites,
    selectedCabinets,
    setSelectedCabinets,
    setFilterSelection,
    isViewStatsEnabled,
    setIsViewStatsEnabled,
    siteDefaultValue,
    cabinetDefaultValue
  } = useDashboardFiltersContext()
  const {t} = useTranslation()

  useEffect(() => {
    setIsViewStatsEnabled(selectedSites?.length && selectedCabinets?.length);
  }, [selectedSites, selectedCabinets]);

  const handleSiteChange = (selectedOptions) => {
    setSelectedSites(selectedOptions)
    setSelectedCabinets([])
    getCabinetsData(selectedOptions)
  }

  const handleViewStats = () => {
    if (isViewStatsEnabled) {
      setFilterSelection({
        sites: selectedSites,
        kiosks: selectedCabinets,
        isManager
      })
    }
  }

  const handleCabinetChange = (selectedOptions) => {
    setSelectedCabinets(selectedOptions)
    if (selectedOptions && selectedOptions.length > 0) {
      setIsViewStatsEnabled(true)
    } else {
      setIsViewStatsEnabled(false)
    }
  }

  const getSelectInputSearch = (rawInput, type) => {
    if (type === 'ENTERHIT') {
      searchSiteName(rawInput)
    }
  }

  const getSelectCabinetInputSearch = (rawInput, type) => {
    if (type === 'ENTERHIT') {
      searchKioskName(rawInput)
    }
  }

  const removeDuplicatesFromObjectArray = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()]
  }

  const searchSiteName = async (value) => {
    let companyID = context.currentUser.claims.companyID
    let sites = []
    setIsLoading(true)
    sites = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('SiteLocations')
        .orderBy('siteName')
        .startAt(value.toUpperCase())
        .endAt(value.toUpperCase() + '\uf8ff')
        .get()
    ).docs.map((doc) => doc.data())

    let finalSitesArray = []

    if (sites.length > 0) {
      finalSitesArray = [
        {label: 'All Sites', value: 'select-all'}
        // { label: 'Unassigned Sites', value: 'Unassigned Sites' }
      ]
      sites.forEach((element) => {
        finalSitesArray.push({
          label: element.siteName,
          value: element.siteName
        })
      })
      setEnableCheckboxForSites(true)
    } else {
      finalSitesArray = [
        // { label: "No Sites available", value: "not-available" },
      ]
      setEnableCheckboxForSites(false)
    }
    setSitesData(removeDuplicatesFromObjectArray(finalSitesArray, 'value'))
    setIsLoading(false)
  }

  const searchKioskName = async (value) => {
    let companyID = context.currentUser.claims.companyID
    let cabinets = []
    setIsLoading(true)
    const sites = selectedSites.map((site) => site.value);
    const siteQuery = await getKioskNames({companyID, sites})
    
    cabinets = siteQuery?.data
      .filter((doc) => doc.id.toUpperCase().startsWith(value.toUpperCase()))
      
    let finalCabinetsArray = []

    if (cabinets.length > 0) {
      if (!isManager) {
        finalCabinetsArray = [
          { label: "All Kiosks", value: "select-all" },
          // { label: 'Unassigned Kiosks', value: 'Unassigned Kiosks' }
        ];
      }
      cabinets.forEach((doc) => {
        finalCabinetsArray.push({label: doc.id, value: doc.id})
      })
      setEnableCheckboxForCabinets(true)
    } else {
      finalCabinetsArray = [
        // { label: "No Kiosks available", value: "not-available" },
      ]
      setEnableCheckboxForCabinets(false)
    }
    setCabinetsData(
      removeDuplicatesFromObjectArray(finalCabinetsArray, 'value')
    )
    setIsLoading(false)
  }

  const getCabinetsData = async (selectedSites = []) => {
    const companyID = context.currentUser.claims.companyID
    let cabinetList = []

    setIsLoading(true)

    try {
      if (selectedSites.length > 0) {
        let sitesToQuery = selectedSites.map((site) => site.value)
        const cabinetsSnapshot = await getKioskNames({companyID, sites:sitesToQuery});
        cabinetsSnapshot?.data.forEach((doc) => {
          cabinetList.push({label: doc.id, value: doc.id})
        })
        cabinetList.sort(customSortAscending)
        if (cabinetList.length > 0) {
          cabinetList.unshift({label: 'All Kiosks', value: 'select-all'})
        }
        setCabinetsData(removeDuplicatesFromObjectArray(cabinetList, 'value'))
        setSelectedCabinets(
          removeDuplicatesFromObjectArray(cabinetList, 'value')
        )
      } else {
        setCabinetsData([])
        setSelectedCabinets([])
      }
    } catch (error) {
      console.error('Error fetching kiosks:', error)
    }
    setIsLoading(false)
  }

  const customSortAscending = (a, b) => {
    const aIsSpecial = /^[^a-zA-Z]/.test(a.label)
    const bIsSpecial = /^[^a-zA-Z]/.test(b.label)

    if (aIsSpecial && !bIsSpecial) return 1
    if (!aIsSpecial && bIsSpecial) return -1
    return a.label.localeCompare(b.label)
  }

  return (
    <div
      className="device-details-button-row"
      style={{justifyContent: 'flex-end', fontWeight: 'normal'}}
    >
      {
        <span
          className="devices-dash-drop"
          style={{display: 'flex', gap: '10px'}}
        >
          <DropdownCustom
            selectOpts={sitesData}
            onChange={handleSiteChange}
            isClearable={false}
            isSearchable={!isManager}
            onSearchInpChange={getSelectInputSearch}
            isLoading={isLoading}
            customFilterOption={() => {
              return sitesData
            }}
            selectOnBlur={() => {}}
            isMulti={true}
            enableCheckbox={enableCheckboxForSites}
            noOptionsMessage="No sites found"
            customPlaceholder={placeholderSites}
            defaultValue={siteDefaultValue}
            selectVal={selectedSites}
            closeMenuOnSelect={false}
            searchOnTextChange={true}
          />
          <DropdownCustom
            selectOpts={cabinetsData}
            onChange={handleCabinetChange}
            isClearable={false}
            isSearchable={true}
            onSearchInpChange={getSelectCabinetInputSearch}
            isLoading={isLoading}
            customFilterOption={() => {
              return cabinetsData
            }}
            selectOnBlur={() => {}}
            isMulti={true}
            enableCheckbox={enableCheckboxForCabinets}
            noOptionsMessage="No kiosks found"
            customPlaceholder={placeholderCabinets}
            defaultValue={cabinetDefaultValue}
            selectVal={selectedCabinets}
            closeMenuOnSelect={false}
            searchOnTextChange={true}
            customStyles={{
              menuList: {
                overflowX: "scroll", "::-webkit-scrollbar": {
                  width: "4px",
                  height: "4px",
                }
              },
              option: { margin: "0 15px 0 0" }
            }}
          />
          <ButtonDiv className="summary-button-div">
            <Button
              type="primary"
              dense={true}
              style={{
                margin: '0px',
                display: 'flex',
                borderRadius: '4px',
                height: '38px',
                lineHeight: '38px'
              }}
              onClick={() => handleViewStats()}
              disabled={!isViewStatsEnabled}
            >
              {t('viewStats')}
            </Button>
          </ButtonDiv>
        </span>
      }
    </div>
  )
}
